import React, { useEffect, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import { getBrandsList } from "../../Redux/Actions/brandsActions";
import { columnsBrands } from "../../Global Functions/columnsAntd";

const ListBrands = () => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchBrandsDetails = (page, pageSize) => {
    const brandsData = {
      page,
      limit: pageSize,
      filter: searchQuery,
    };
    dispatch(getBrandsList(brandsData));
  };

  useEffect(() => {
    fetchBrandsDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { brands } = useSelector((state) => state.brands);

  useEffect(() => {
    if (brands?.total) {
      setPagination((prevData) => ({ ...prevData, total: brands.total }));
    }
  }, [brands]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchBrandsDetails(pagination.current, pagination.pageSize);
  };

  const filterHandler = () => {
    setPagination((prevData) => ({ ...prevData, current: 1 }));
    fetchBrandsDetails(1, pagination.pageSize);
  };

  return (
    <TableComponent
      h3heading="Brands List"
      dataSource={Array.isArray(brands?.data) ? brands.data : []}
      buttonhead2={canAdd ? "Add Brands" : null}
      setState={setSearchQuery}
      filterFunction={filterHandler}
      navigateTo2={canAdd ? "/brands/add" : null}
      onChange={handleTableChange}
      columns={columnsBrands}
      pagination={pagination}
    ></TableComponent>
  );
};

export default ListBrands;
